import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { uploadArraySelector } from '@air/redux-uploader';

import { getUploadsNeedingPreview } from '../utils/getUploadsNeedingPreview';
import { UploadPreviewLoader } from './UploadPreviewLoader';

export const UploadPreviewLoaders = memo(() => {
  const uploads = useSelector(uploadArraySelector);
  const uploadsNeedingPreview = useMemo(() => getUploadsNeedingPreview(uploads), [uploads]);

  return (
    <>
      {uploadsNeedingPreview.map((upload) => (
        <UploadPreviewLoader key={upload.id} upload={upload} />
      ))}
    </>
  );
});

UploadPreviewLoaders.displayName = 'UploadPreviewLoaders';
